// extracted by mini-css-extract-plugin
module.exports = {"comment-input":"CommentInput_comment-input__9eZD9"};